module.exports = __webpack_public_path__ + "static/media/nalgonda.48c42303.png";